export default __webpack_public_path__ + "assets/robin.3e474c0a.webp";